export enum ApprovalEnum{

    APPROVAL_NAME=-500,
    APPROVAL_STATUS=-501,
    APPROVAL_APPROVED_BY=-502,
    APPROVAL_APPROVED_DATE=-503,
    APPROVAL_APPROVED_DATE_TIME=-504,
    APPROVAL_REMARKS=-505
}